import { CurrencyPipe } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { RouterHandlerService } from "../../../../services/router-handler.service";
import * as d3 from "d3";
import * as _ from "lodash";
import moment from "moment";
import { FilterService } from "../../../../services/filter.service";
import { NavigationService } from "../../../../services/navigation.service";
import { DeviceDetectionService } from "../../../../services/detectipad.service";
import { UserActivityService } from "../../../../services/useractivity.service";
import { DashboardService } from "../../../../services/dashboard.service";
import { IrCommectPopupComponent } from "../../ir-comment-popup/ir-comment-popup.component";

@Component({
    selector: "app-new-heatmap-chart",
    templateUrl: "./new-heatmap-chart.component.html",
    styleUrls: ["./new-heatmap-chart.component.scss"],
    standalone: false
})
export class NewHeatmapChartComponent implements OnInit, OnChanges {
  @ViewChild("heatmapContainer", { static: true })
  heatmapContainer!: ElementRef;
  divId: string = "heatmapContainer";
  _clickTimer: any = null;
  math = Math;

  constructor(
    private currency: CurrencyPipe,
    private filterService: FilterService,
    private routerHandlerService: RouterHandlerService,
    private navigationService: NavigationService,
    public elementRef: ElementRef,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public deviceDetectionService: DeviceDetectionService,
    private userActivityService: UserActivityService
  ) {
    // This is used for setting up the route to the control chart
    this.route.params.subscribe((p: any) => {
      this.queryParams = p;
      this.moduleName = p["module"] || "";

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });
  }

  list: any = [];
  @Input("data") data: any;
  @Input("props") props: any;
  @Input("config") config: any;
  @Input("item") item: any;
  @Input("commentsData") commentsData: any = [];
  @Input("selectedValue") selectedValue: any;
  @Input("fullscreen") fullscreen: any;
  initiateChart: boolean = false;
  tooltipVisible: any = false;
  mytooltipData: any;
  simpleTooltipText: string = "";
  simpleTooltipVisible: boolean = false;
  dataTurn: any;
  scrollLeft: any = 0;
  scrollWidth: any = 0;
  scrollRight: any = 0;
  Right: boolean = false;
  Left: boolean = false;
  myX: any;
  myY: any;
  currentYAxisWidth: any;

  scatter: boolean = false;
  upperBound = 2;
  lowerBound = -2;
  redFade: any;
  greenFade: any;
  green: string = "#2dc887";
  red: string = "#D01345";
  blue: string = "#655ade";
  // Vars for to set up control chart
  clientKey: any;
  moduleKey: any;
  dashboardKey: any;
  compare: any;
  moduleName: any;
  decryptedParams: any = {};
  queryParams: any;

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    setTimeout(() => {
      this.plotChart();
    }, 300);
  }

  @Output() gridData = new EventEmitter();
  selectedRows: Set<number> = new Set();
  numberRange: any;
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.["data"]?.currentValue != changes?.["data"]?.previousValue &&
      this.initiateChart
    ) {
      this.selectedRows.clear();
      this.plotChart();
    }
    if (
      changes?.["selectedValue"]?.currentValue !=
        changes?.["selectedValue"]?.previousValue &&
      this.initiateChart
    ) {
      this.selectedRows.clear();
      this.plotChart();
    }
    if (
      changes?.["fullscreen"]?.currentValue !=
        changes?.["fullscreen"]?.previousValue &&
      this.initiateChart
    ) {
      // Keep the selection across the fullscreen transition — the data and both axes are
      // unchanged, so plotChart re-applies it and the linked grid keeps the same rows.
      this.plotChart();
    }
    if (
      changes?.["props"]?.currentValue != changes?.["props"]?.previousValue &&
      this.initiateChart
    ) {
      this.selectedRows.clear();
      this.plotChart();
    }
  }
  ngOnInit() {
    this.divId = this.divId + this.item.widget_uniq_key;

    // TODO: Replace dummy comment config with actual data from backend
    if (!this.item.config) {
      this.item.config = {};
    }
    if (!this.item.config['comments_api']) {
      this.item.config['comments_api'] = {
        comments_api_key: '100132'
      };
    }
    if (!this.item.config['notes_selected_key']) {
      this.item.config['notes_selected_key'] = [
        { api_resp_column_nm: 'page_nm' },
        { api_resp_column_nm: 'period' },
        { api_resp_column_nm: 'source_name' }
      ];
    }
    if (!this.item.config['report_type_selection']) {
      this.item.config['report_type_selection'] = [
        { action_typ: 'INSERT', report_typ: 'I' },
        { action_typ: 'DELETE', report_typ: 'D' },
        { action_typ: 'UPDATE', report_typ: 'U' },
        { action_typ: 'SELECT SOURCE', report_typ: 'S' },
        { action_typ: 'SELECT LOCATION', report_typ: 'S' }
      ];
    }

    this.initiateCharts();
    // this.plotChart()
  }
  ngAfterViewInit(): void {
    this.scrollLeft = 0;
    this.scrollWidth = 0;
    this.scrollRight = 0;
    document
      .getElementById("heatmapContainer")
      ?.addEventListener("scroll", (event: any) => {
        this.scrollLeft = event?.target?.scrollLeft;
        this.scrollWidth = event?.target?.scrollWidth;
        this.scrollRight = this.scrollWidth - this.scrollLeft;
        if (this.scrollLeft == 0) {
          this.scrollRight = 0;
          this.scrollWidth = 0;
        }
      });
  }

  calculateZScores(values: any) {
    // Get object of distinct sources, kpis, and locations and their accompanying previous periods
    let distinctPeriods: any = [];
    values.forEach((entry: any) => {
      // check if this distinct source exists in our data object
      // find matching source, kpi, and location for a distinct souce
      const distinctSourcePeriods = distinctPeriods.find(
        (obj: any) =>
          entry.x_axis_value === obj.x_axis_value &&
          entry.y_axis_value === obj.y_axis_value &&
          entry.sp_location_name === obj.sp_location_name
      );
      // We have already added this source so update period
      if (distinctSourcePeriods) {
        distinctSourcePeriods.periods.push({
          period: entry.period,
          kpi_value: entry.kpi_value,
        });
      }
      // Source has not been added so create it in distinctPeriods
      else {
        distinctPeriods.push({
          // "source_name": entry.x_axis_value,
          // "kpi_nm": entry.y_axis_value,
          // "sp_location_name": entry.sp_location_name,
          x_axis_value: entry.x_axis_value,
          y_axis_value: entry.y_axis_value,
          periods: [{ period: entry.period, kpi_value: entry.kpi_value }],
        });
      }
    });
    // console.log(distinctPeriods);
    // we have everything we need to calculate z scores now

    values.forEach((entry: any) => {
      // if (entry["periods"]){
      const myPeriods = distinctPeriods.find(
        (obj: any) =>
          entry.x_axis_value === obj.x_axis_value &&
          entry.y_axis_value === obj.y_axis_value &&
          entry.sp_location_name === obj.sp_location_name
      ).periods;

      let valuesToLookCalculate = myPeriods;
      valuesToLookCalculate = _.sortBy(valuesToLookCalculate, "period");
      // let valuesToLookCalculate = entry["periods"];
      // make sure we have data
      let ucl = 0;
      let lcl = 0;
      let stdev = entry?.no_of_std_deviations ?? 2;
      if (valuesToLookCalculate.length > 0) {
        const currentDate = entry.period;
        const currentDateIndex = valuesToLookCalculate.findIndex(
          (period: any) => period.period === currentDate
        );
        // get starting date index but default to 0 if the index is negative
        let calculationStartDate =
          currentDateIndex - entry["lookback_period"] < 0
            ? 0
            : currentDateIndex - entry["lookback_period"];

        valuesToLookCalculate = valuesToLookCalculate.slice(
          calculationStartDate,
          currentDateIndex
        );
        // make sure array is not empty after slicing
        if (valuesToLookCalculate.length > 0) {
          const sum = valuesToLookCalculate.reduce(
            (acc: any, val: any) => acc + val["kpi_value"],
            0
          );
          let avg = sum / valuesToLookCalculate.length;
          const squaredDifferences = valuesToLookCalculate.map((val: any) =>
            Math.pow(val["kpi_value"] - avg, 2)
          );
          const sumOfSquaredDifferences = squaredDifferences.reduce(
            (acc: any, val: any) => acc + val,
            0
          );
          const variance =
            sumOfSquaredDifferences / valuesToLookCalculate.length;
          var dev = Math.sqrt(variance);
          lcl = avg - stdev * dev;
          ucl = avg + stdev * dev;
          lcl < 0 ? lcl = 0 : lcl;
          ucl < 0 ? ucl = 0 : ucl;
          if (dev != 0) {
            const z_score = ((entry["kpi_value"] - avg) / dev).toFixed(2);
            entry["z_score"] = z_score;
          } else {
            entry["z_score"] = 0;
          }
        } else {
          entry["z_score"] = 0;
        }
      } else {
        entry["z_score"] = 0;
      }
      entry["lower_control_limit"] = lcl;
      entry["upper_control_limit"] = ucl;
      // }
      // else{
      //   entry["periods"] = [];
      //   entry["z_score"] = 0;
      //   entry["current_date"] = "unknown";
      // }
    });
    return values;
  }

  navigationImplementation(config0: any, cardId: any, myData: any) {
    let nav = {
      dbJSON: config0?.dbJSON,
      s3JSON: config0?.s3JSON,
      pageName: config0?.pageName,
      isDashboardLevel: config0?.isDashboardLevel,
    };
    this.lookBackUsingDateFilter(config0?.dbJSON);
    sessionStorage.setItem("navDetailInfo", JSON.stringify(nav));
    // debugger

    let selectedFilter = "";
    for (let key in myData) {
      selectedFilter += myData[key]?.toString?.() ?? "";
    }

    let query: any = Object.assign(
      {},
      this.decryptedParams,
      { cardId: cardId },
      { tab_id: 0 },
      { f_q: selectedFilter },
      { record: "yes" }
    );
    let queryMaped = this.navigationService.movePropertyToFirst(
      query,
      "tab_id"
    );
    this.navigationService.routerNavigate(
      `dashboard/${this.moduleName}/${"comparison"}`,
      queryMaped
    );
  }

  lookBackUsingDateFilter(arr: any) {
    if (arr) {
      sessionStorage.setItem("dashboardControl", JSON.stringify(arr));
    }
  }

  // when a single node is compared
  private notCompareClick(myData: any): void {
    // debugger
    if (myData["sp_location_key"]) {
      myData["sp_location_key"] = myData["sp_location_key"]?.toString();
    }
    let config = this.item?.["config"];
    if (config?.nav_configuration) {
      const config0 = config?.nav_configuration?.["controls"].find((o: any) =>
        o.chartType.includes("Single")
      );
      this.navigationImplementation(config0, "single", myData);
      this.routerHandlerService.storingPayloadAndFilterForGrid(
        config0,
        myData,
        ""
      );
    }
    // this.router.navigate([`dashboard/${this.clientKey}/${this.moduleKey}/${this.dashboardKey}/comparison/single`], { queryParams: query, queryParamsHandling: 'merge', skipLocationChange: false });
  }

  showTooltip(
    myType: any,
    myData: any,
    myX: any,
    myY: any,
    chartWidth: any,
    color: any = null
  ): void {
    // console.log(myType,this.scrollTop,'type')
    this.mytooltipData = myData;
    if (color) {
      this.mytooltipData.color = color;
    }
    this.dataTurn = 0;
    const chartWidths: any =
      document.getElementById("heatmapContainer")?.clientWidth;
    this.dataTurn = chartWidths - myX;
    this.tooltipVisible = true;
    this.myX = myX;
    this.myY = myY;
    if (this.dataTurn < 250) {
      this.Right = true;
      this.Left = false;
      d3.select("#ItSummeryTooltip")
        .style("visibility", "visible")
        .style("position", "fixed")
        .style("top", myY + 75 + "px")
        .style("right", this.dataTurn + this.scrollLeft + "px")
        .style("left", "unset")
        .style("bottom", "unset");
    } else if (this.dataTurn > 250) {
      this.Right = false;
      this.Left = true;
      d3.select("#ItSummeryTooltip")
        .style("visibility", "visible")
        .style("position", "fixed")
        .style("top", myY + 75 + "px")
        .style("left", myX + 70 - this.scrollLeft + "px")
        .style("right", "unset")
        .style("bottom", "unset");
    }
  }
  hideTooltip(visible: any): void {
    setTimeout(() => {
      this.tooltipVisible = false;
      d3.select("#ItSummeryTooltip").style("visibility", "hidden");
    }, 100);
  }

  showSimpleTooltip(event: any, text: string, marginTop: number) {
    this.simpleTooltipText = text;
    this.simpleTooltipVisible = true;
    const tooltip = d3.select("#SimpleTooltip");
    // Get coordinates relative to the heatmapContainer
    const [x, y] = d3.pointer(event, this.heatmapContainer.nativeElement);

    tooltip
      .style("visibility", "visible")
      .style("position", "absolute")
      .style("top", y + marginTop + "px")
      .style("left", x + 10 + "px")
      .style("background", "white")
      .style("padding", "5px 10px")
      .style("border", "1px solid #ccc")
      .style("border-radius", "4px")
      .style("box-shadow", "0 2px 5px rgba(0,0,0,0.2)")
      .style("z-index", "10000")
      .style("pointer-events", "none");
  }

  hideSimpleTooltip() {
    this.simpleTooltipVisible = false;
    d3.select("#SimpleTooltip").style("visibility", "hidden");
  }
  initiateCharts(): void {
    // only need to call this once on initialisation
    const myChart = this;
    const myClass = myChart.divId;
    //legend
    const legendSvg = d3
      .select("#legendDiv")
      .append("svg")
      .attr("id", "svg_legendDiv" + myClass)
      .attr("width", "400px")
      .style("background-color", "white");

    // Frozen pane SVG (row labels + Total column). Scoped to this component's host
    // so multiple heatmap instances on the same page don't collide on the #Yaxis id.
    d3.select(this.elementRef.nativeElement)
      .select("#Yaxis")
      .append("svg")
      .attr("id", "svg_Yaxis" + myClass)
      .style("display", "block")
      .style("background-color", "white");

    const Svg = d3
      .select(this.heatmapContainer.nativeElement)
      .append("svg")
      .attr("id", "svg_" + myClass)
      .attr("width", "auto")
      .style("background-color", "white")
      .style("margin-bottom", "10px");

    this.initiateChart = true;
  }

  // legendValue:any = [{ name: "0-20%", color: "#3DC77B" }, { name: "20-40%", color: "#9CE4BD" },{ name: "40-60%", color: "#E3E3E3" }, { name:"60-80%", color: "#ECA1B5" }, { name: "80-100%", color: "#D01345" }]
  async plotChart(animate: boolean = true) {
    const myChart = this;
    const cfg = this.item?.config;
    const myClass = myChart.divId;
    const legendSvg = d3.select("#svg_legendDiv" + myClass);
    const svgcontainer = d3.select("#svg_" + myClass);
    const Yaxisxcontainer = d3.select("#svg_Yaxis" + myClass);
    const width: any = this.heatmapContainer?.nativeElement?.clientWidth; //svgNode ? svgNode.getBoundingClientRect().width : 0;
    // buildFrozenPane() re-parents the Y-axis group and the Total column's x-axis tick
    // into the fixed overlay SVG at the end of every render. Lookups that run after that
    // (the tick click handlers) must therefore search the whole component host, not just
    // the scrolling chart SVG, or they match nothing.
    const axisRoot = () => d3.select(myChart.elementRef.nativeElement);

    let MaxValue: any;
    let min: any;
    let cellGap = cfg?.cell_gap ?? 0.01; // default cell gap
    let cellwidth = cfg?.cell_width ?? 80; // default cell width
    let cellheight = cfg?.cell_height ?? 50; // default cell height
    let axisTop = (myChart?.props?.position == "top" || cfg?.axisTop) ?? false; // default top margin
    let cellRadius = cfg?.cell_radius ?? true; // default cell radius
    let showCellValue = cfg?.show_cell_value ?? false; // default show cell value
    let selectYaxis = cfg?.selectYaxis ?? false; // default show Y axis
    let selectXaxis = cfg?.selectXaxis ?? false; // default show X axis
    let isYAxisResizable = cfg?.isYAxisResizable ?? false; // default Y axis resizable
    let colorGradient = cfg?.colorGradient ?? false; // default color gradient
    let isTooltipShow = cfg?.isTooltipShow ?? true; // default tooltip visibility
    let isNav = cfg?.isNav ?? true; // default navigation on click
    let dynamicWidth = cfg?.dynamicWidth ?? false; // default dynamic width
    let pseudoDate = cfg?.pseudoDate ?? "2050-01-01T00:00:00"; // default pseudo date
    let XaxisOrder = cfg?.XaxisOrder?.value ?? "descending"; //"ascending"
    let YaxisOrder = cfg?.YaxisOrder?.value ?? "ascending"; //"ascending"

    // check to see if chart is importing data from scatter plot
    myChart.scatter = cfg?.import_from_scatter_plot?.value === "true" || false;

    const data = myChart.scatter ? this.calculateZScores(this.data) : this.data; //await fetch('assets/json/heatmap.json').then(a => a.json())

    if (myChart.scatter) {
      MaxValue = d3.max(this.data, (d: any) => +d["z_score"]) || Infinity;
      min = d3.min(this.data, (d: any) => +d["z_score"]) ?? Infinity;
      myChart.selectedValue = "value";
    } else {
      MaxValue = getMinMax(
        this.data,
        cfg?.max_value?.map((column: any) =>
          column.total_flg == "Y" ? 0 : column.api_resp_column_nm
        ),
        "max"
      ); //d3.max(this.data, (m: any) => Math.max( ${generatevalue()}));
      MaxValue = MaxValue == 0 ? 5 : MaxValue;
      // const MinValue: any = d3.min(this.data, (m: any) => Math.min(m['dispense_qty'], m['inventory_qty'], m['qty_difference']));
      min = getMinMax(
        this.data,
        cfg?.min_value?.map((column: any) => column.api_resp_column_nm),
        "min"
      );
    }

    const DiffMinValue: any = min >= -100 ? -100 : min;
    const intervals: Array<[number, number]> = [
      [DiffMinValue, DiffMinValue * (2 / 3)], // 1st part
      [DiffMinValue * (2 / 3), DiffMinValue * (1 / 3)], // 2nd part
      [DiffMinValue * (1 / 3), -0.0000001],
      // [-100, -66.7],
      // [-66.7, -33.4],
      // [-33.4, 0],
      [0, 0], // for zero
      [0.0000001, 33.4],
      [33.4, 66.7],
      [66.7, 100],
    ];
    // console.log(intervals);

    function getMinMax(data: any, columns: any, type: "min" | "max") {
      if (type === "min") {
        return data.reduce((min: any, m: any) => {
          const currentMin = Math.min(
            ...columns.map((col: any) => (m.total_flg === "Y" ? 0 : m[col]))
          );
          return currentMin < min ? currentMin : min;
        }, 0);
      } else if (type === "max") {
        return data.reduce((max: any, m: any) => {
          const currentMax = Math.max(
            ...columns.map((col: any) => (m.total_flg === "Y" ? 0 : m[col]))
          );
          return currentMax > max ? currentMax : max;
        }, 0);
      } else {
        throw new Error('Invalid type argument. Expected "min" or "max".');
      }
    }

    // console.log(MinValue);'#1F10D1','#6258DF','#8F87E8','#BCB7F1','#DDDBF8'

    const result = splitNumberIntoRanges(MaxValue, 3);
    let XaxisVar: string;
    // const XaxisVar = "period"; //"period"
    // const YaxisVar = "distinct_name"; //"source_name"
    let YaxisVar: string;
    let valueVar: string;
    // const valueVar = "z_score"; //"qty_difference"
    if (myChart.scatter) {
      XaxisVar = "period"; //"period"
      YaxisVar = "distinct_name";
      valueVar = "z_score";
    } else {
      XaxisVar = myChart.config[myChart.selectedValue].XaxisVar; //"period"
      YaxisVar = myChart.config[myChart.selectedValue].YaxisVar; //"source_name"
      valueVar = myChart.config[myChart.selectedValue].valueVar; //"qty_difference"
    }

    const tickFormat: any = {
      D: "%d %b %Y",
      W: "%d %b %Y",
      M: "%b %Y",
      Q: "%b %Y",
      Y: "%Y",
    };
    const xTickFormat: any = d3.timeFormat(
      tickFormat[this.filterService.report_type]
    );
    const colorStops: any = [
      -1.0001, -0.6667, -0.3333, 0.01, 0.3333, 0.6667, 1,
    ]; //[-1, -0.8, -0.6, -0.4, -0.2, 0.00001, 0.2, 0.4, 0.6, 0.8, 1] // [0.00001, 0.2, 0.4, 0.6, 0.8, 1];
    let colorRange: any =
      myChart.selectedValue == "percent"
        ? [
            "#1F10D1B2",
            "#1F10D180",
            "#1F10D14D",
            "#3DC77B",
            "#F1B7C7",
            "#ECA1B5",
            "#D01345",
          ]
        : [
            "#1F10D1B2",
            "#1F10D180",
            "#1F10D14D",
            "#3DC77B",
            "#F1B7C7",
            "#ECA1B5",
            "#D01345",
          ];
    // let colorLabels: any = ["0%", "1 to 20%", "20 to 40%", "40 to 60%", "60 to 80%", "80 to 100%"];
    // let colorLabels: any = ["-100% to -80%", "-80% to -60%", "-60% to -40%", "-40% to -20%", "-20% to 0%", "0%", "1 to 20%", "20 to 40%", "40 to 60%", "60 to 80%", "80 to 100%"    ];
    // let colorLabels: any = ["(-100%) to (-66.67%)", "(-66.66%) to (-33.34%)", "(-33.33%) to (-1%)", "0%", "1% to 33.33%", "33.34% to 66.66%", "66.67% to 100%"  ];
    let colorLabels: any = [
      "(" +
        numberFormating(DiffMinValue?.toFixed(3)) +
        "%) to (" +
        numberFormating((DiffMinValue * (2 / 3))?.toFixed(3)) +
        "%)",
      "(" +
        numberFormating((DiffMinValue * (2 / 3))?.toFixed(3)) +
        "%) to (" +
        numberFormating((DiffMinValue * (1 / 3))?.toFixed(3)) +
        "%)",
      "(" +
        numberFormating((DiffMinValue * (1 / 3))?.toFixed(3)) +
        "%) to (-0.1%)",
      "0%",
      "0.1% to 33.33%",
      "33.34% to 66.66%",
      "66.67% to 100%",
    ];
    let colorScale: any;
    let thresholds: any;
    const minValue = 0;
    const maxValue = this.selectedValue == "percent" ? 100 : MaxValue;
    const midValue = (minValue + maxValue) / 2;
    const dateColumnWidth = 110;
    if (myChart.selectedValue == "value") {
      colorLabels = result;
    }
    let filterValue =
      this.filterService?.baseQuery?.["patient_type_name"] || "default";
    if (colorGradient) {
      thresholds =
        filterValue == "Linked" || filterValue == "Linked,Unlinked"
          ? [
              {
                value: minValue,
                color: cfg?.maxcolor || "#E25219",
                showLabel: true,
              },
              {
                value: midValue,
                color: cfg?.midcolor || "yellow",
                showLabel: false,
              },
              {
                value: maxValue,
                color: cfg?.mincolor || "#6DB139",
                showLabel: true,
              },
            ]
          : [
              {
                value: minValue,
                color: cfg?.mincolor || "#6DB139",
                showLabel: true,
              },
              {
                value: midValue,
                color: cfg?.midcolor || "yellow",
                showLabel: false,
              },
              {
                value: maxValue,
                color: cfg?.maxcolor || "#E25219",
                showLabel: true,
              },
            ];

      // ===== COLOR SCALE =====
      colorScale = d3
        .scaleLinear<string, number>()
        .domain([minValue, midValue, maxValue])
        .range([
          thresholds[0].color || cfg?.mincolor || "#6DB139",
          thresholds[1].color || cfg?.midcolor || "yellow",
          thresholds[2].color || cfg?.maxcolor || "#E25219",
        ])
        .clamp(true);
    }
    // Helper to get unique values in order of appearance (DBOrder)
    const unique = (arr: any[]) => [...new Set(arr)];

    // Extract unique values
    let myGroups = unique(data.map((d: any) => d[XaxisVar])); // X-axis: groups
    let myVars = unique(data.map((d: any) => d[YaxisVar])); // Y-axis: variables

    // Sort X-axis (unchanged)
    if (XaxisOrder === "ascending") {
      myGroups.sort((a, b) => String(a).localeCompare(String(b)));
    } else if (XaxisOrder === "descending") {
      myGroups.sort((a, b) => String(b).localeCompare(String(a)));
    }

    // Sort Y-axis based on cell values (sum)
    // First, calculate the total value for each Y-axis group
    const yGroupTotals = myVars.map((yVar: any) => {
      const groupData = data.filter((d: any) => d[YaxisVar] === yVar);
      // Calculate sum of values for this group
      // Adjust 'valueVar' if needed, but it should be correct from your config
      const sum = groupData.reduce(
        (acc: number, d: any) => acc + (parseFloat(d[valueVar]) || 0),
        0
      );
      return { name: yVar, total: sum };
    });

    // Sort the groups by their total value
    // Check YaxisOrder to determine ascending or descending
    if (YaxisOrder === "ascending") {
      yGroupTotals.sort((a: any, b: any) => a.total - b.total);
    } else if (YaxisOrder === "descending") {
      yGroupTotals.sort((a: any, b: any) => b.total - a.total); // Descending order
    } else {
      // Default to descending if not specified or 'DBOrder'
      yGroupTotals.sort((a: any, b: any) => b.total - a.total);
    }

    // Extract the sorted names back into myVars
    myVars = yGroupTotals.map((item: any) => item.name);

    // debugger
    // set the dimensions and margins of the graph
    // var margin:any = { leftColumn: 0, top: axisTop ? 65 : 10, right: 40, bottom: axisTop ? 10 : 65, left: 40 };
    var margin: any = {
      leftColumn: 0,
      top: axisTop ? 65 : 10,
      right: 40,
      bottom: axisTop ? 10 : 65,
      left: 40,
    };

    if (cellwidth >= 62) {
      margin.bottom = axisTop ? margin.bottom : 30;
      margin.top = axisTop ? 30 : margin.top;
    } else {
    }

    margin.bottom = axisTop
      ? margin.bottom
      : (myChart.props?.xAxisFontSize - 10) * 8 + margin.bottom;
    margin.top = axisTop
      ? (myChart.props?.xAxisFontSize - 10) * 8 + margin.top
      : margin.top;
    if (myChart?.props?.position == "top") {
      margin.top = myChart.props?.xAxisShow ? margin.top : 5;
    } else {
      margin.bottom = myChart.props?.xAxisShow ? margin.bottom : 5;
    }

    // const mySvg: any = d3.select('#svg_' + myClass);
    legendSvg
      .attr("height", 20)
      .attr(
        "width",
        dateColumnWidth * (myChart.selectedValue == "percent" ? 7 : 7)
      );
    const periodlength: any = new Set(myGroups); //x-axis
    const sourcelength: any = new Set(myVars); //y-axis
    // const width: any = svgcontainer?.node()?.getBoundingClientRect()?.width;

    let maxFullWidth = 0;
    let maxTruncatedWidth = 0;

    if (myChart.scatter) {
      legendSvg.attr("height", 30).attr("width", 800);
      margin.bottom = margin.bottom;
      margin.left = margin.left + 20;
      colorRange = [
        "#1F10D1B2",
        "#1F10D180",
        "#8fddb2",
        "#3bc77d",
        "#8fddb2",
        "#d47993",
        "#D01345",
      ];
    }

    data.forEach((d: any) => {
      let text = d[YaxisVar];
      let fullWidth = 0;
      let truncatedWidth = 0;

      let fontSize = (myChart.props?.yAxisFontSize || 12) + "px";
      if (myChart.scatter) {
        const words = text.split(" / ");
        // Find max width among words
        fullWidth =
          d3.max(words, (word: any) => myChart.getTextWidth(word, fontSize)) ||
          0;
        truncatedWidth =
          d3.max(words, (word: any) => {
            const truncatedWord =
              word.length > 18 ? word.substring(0, 18) + "..." : word;
            return myChart.getTextWidth(truncatedWord, fontSize);
          }) || 0;
      } else {
        fullWidth = myChart.getTextWidth(text, fontSize);
        const truncatedText =
          text.length > 18 ? text.substring(0, 18) + "..." : text;
        truncatedWidth = myChart.getTextWidth(truncatedText, fontSize);
      }

      if (fullWidth > maxFullWidth) maxFullWidth = fullWidth;
      if (truncatedWidth > maxTruncatedWidth)
        maxTruncatedWidth = truncatedWidth;
    });

    margin.left = myChart.props?.yAxisShow ? margin.left : 5;

    const padding = (isNav ? 18 : 0) + 200; // Arrow space + general padding
    const maxLabelWidthPx = maxFullWidth + padding;
    const minLabelWidthPx = maxTruncatedWidth + (isNav ? 18 : 0); // Initial width (truncated)

    if (isYAxisResizable) {
      if (this.currentYAxisWidth === undefined) {
        this.currentYAxisWidth = minLabelWidthPx;
      }
      margin.left =
        margin.left + this.currentYAxisWidth + myChart.props?.yAxisFontSize * 2;
    } else {
      // Default behavior if resize is disabled
      margin.left = margin.left + maxFullWidth + 20;
      this.currentYAxisWidth = maxFullWidth; // Sync for label positioning if needed, or use separate logic
    }
    const availableWidth = width - margin.left - margin.right;
    let widths: number;
    if (dynamicWidth) {
      widths = availableWidth;
    } else {
      const calculatedWidth = myChart.scatter
        ? 32 * periodlength.size
        : cellwidth * periodlength.size;
      if (calculatedWidth < availableWidth) {
        // Adjust cell width to fill the available space
        cellwidth = availableWidth / periodlength.size;
        widths = availableWidth;
      } else {
        widths = calculatedWidth;
      }
    }
    // const height = 160 + margin.top + margin.bottom;
    const height = myChart.scatter
      ? 40 * sourcelength.size
      : cellheight * sourcelength.size;
    // const widths = width - margin.left - margin.right;
    // margin.leftColumn = (width - margin.left - margin.right) / 5.1

    drawLegend(colorRange);

    // Legend
    function drawLegend(legendData: any) {
      // If colorGradient is enabled, render gradient bar (ignore legendGroup)
      if (colorGradient) {
        // ===== RENDER =====
        const width = 400;
        const height = 20;
        // Clear previous gradient content
        legendSvg.selectAll("*").remove();

        // Create centered gradient bar inside legendSvg (NOT new #gradient-container)
        const svg = legendSvg
          .attr("width", "100%")
          .attr("height", height)
          .attr("viewBox", `0 0 ${width + 30} ${height}`)
          .attr("preserveAspectRatio", "xMidYMid meet");

        const centerX = (width + 30) / 2;
        const barGroup = svg
          .append("g")
          .attr("transform", `translate(${centerX - width / 2}, ${0})`);

        // Define gradient
        const defs = svg.append("defs");
        const gradient = defs
          .append("linearGradient")
          .attr("id", "autoGradient")
          .attr("x1", "0%")
          .attr("y1", "0%")
          .attr("x2", "100%")
          .attr("y2", "0%");

        thresholds.forEach(({ value, color }: any) => {
          const offset = ((value - minValue) / (maxValue - minValue)) * 100;
          gradient
            .append("stop")
            .attr("offset", `${offset}%`)
            .attr("stop-color", color);
        });

        // Draw bar
        barGroup
          .append("rect")
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", width)
          .attr("height", height)
          .attr("fill", "url(#autoGradient)");

        // Ticks & Labels using join
        const tickGroups = barGroup
          .selectAll(".legendGroup")
          .data(thresholds)
          .join((enter) => {
            const g = enter.append("g").attr("class", "legendGroup");
            g.append("text")
              .attr("class", "legendLabel")
              .attr("text-anchor", "middle");
            return g;
          });

        tickGroups.attr("transform", (d: any) => {
          const xPos = width * ((d.value - minValue) / (maxValue - minValue));
          return `translate(${xPos}, 0)`;
        });

        tickGroups
          .select(".legendLabel")
          .attr("y", 13)
          .attr("x", (d: any, i: any) =>
            i == thresholds.length - 1 ? 25 : -15
          )
          .attr("class", "label")
          .attr("fill", "#101D42")
          .attr("font-weight", "600")
          .attr("font-family", "Poppins")
          .attr("font-size", "12px")
          .text((d: any) =>
            d.showLabel
              ? d3.format(",")(d.value) +
                (myChart.selectedValue == "percent" ? "%" : "")
              : ""
          );

        return; // EXIT — don’t process legendGroup
      }

      const legendGroup = legendSvg
        .selectAll(".legendGroup")
        .data(legendData)
        .join(function (group: any): any {
          const enter = group.append("g").attr("class", "legendGroup");
          enter.append("rect").attr("class", "legendRect");
          enter.append("text").attr("class", "legendLabel");
          return enter;
        });

      if (myChart.scatter) {
        // Make sure our squares are in a gradient, do not show values above the legend, and certain labels
        legendGroup
          .select(".legendRect")
          .attr("y", 20)
          .attr(
            "x",
            (d: any, i: any) => 20 + i * dateColumnWidth + margin.leftColumn * 2
          )
          .attr("width", dateColumnWidth - 6)
          .attr("height", 6)
          .attr("fill", (d: any) => {
            return d;
          });
        // Add "Dip" at the beginning of legend
        // const legendNodes = legendGroup.nodes();
        const first = legendGroup.filter((_, i) => i === 0);
        const last = legendGroup.filter((_, i) => i === legendGroup.size() - 1);
        const middle = legendGroup.filter(
          (_, i) => i === Math.floor(legendGroup.size() / 2)
        );

        // Function to add a label above a legend group
        function addCenteredLabel(
          group: d3.Selection<any, unknown, any, any>,
          label: string
        ) {
          const rect = group.select<SVGRectElement>("rect");

          const x = +rect.attr("x"); // x position of the rect
          const width = +rect.attr("width");

          group.selectAll(".scatter-legend-label").remove();

          group
            .append("text")
            .attr("class", "scatter-legend-label")
            .attr("x", x + width / 2) // center over the rect
            .attr("y", 10) // above the rect
            .attr("text-anchor", "middle") // center-align the text
            .attr("fill", "#a2afbf")
            .attr("font-size", "12px")
            .text(label);
        }

        addCenteredLabel(first, "Dip");
        addCenteredLabel(last, "Spike");
        addCenteredLabel(middle, "Mean");
      } else {
        legendGroup
          .select(".legendRect")
          .attr("y", 20 - 8)
          .attr(
            "x",
            (d: any, i: any) => 20 + i * dateColumnWidth + margin.leftColumn * 2
          )
          .attr("width", dateColumnWidth - 6)
          .attr("height", 6)
          .attr("fill", (d: any) => d);

        legendGroup
          .select(".legendLabel")
          .attr("fill", "#8A98AB")
          .attr("font-weight", "500")
          .attr("font-family", "Poppins")
          .attr("font-size", "9.5")
          .attr("text-anchor", "middle")
          .attr("y", 20 - 10)
          .attr(
            "x",
            (d: any, i: any) =>
              i * dateColumnWidth +
              margin.leftColumn * 2 +
              dateColumnWidth / 2 +
              15
          )
          .text((d: any, i: any) => colorLabels[i]?.toUpperCase());
      }
    }

    // append the svg object to the body of the page
    // Only remove the chart content, preserve the resize group
    svgcontainer.selectAll(".chart-content").remove();
    const svg = svgcontainer
      .attr("width", widths + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .classed("chart-content", true)
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // Build X scales and axis:
    var x: any = d3
      .scaleBand()
      .range([0, widths])
      .domain(myGroups)
      .padding(cellGap);
    svg
      .append("g")
      .classed("x-axis", true)
      .attr("visibility", !myChart?.props?.xAxisShow ? "hidden" : "visible")
      .style("font-size", myChart?.props?.xAxisFontSize || 10)
      .style("font-family", "Poppins")
      .style("font-weight", myChart?.props?.xAxisBold ? "bold" : 500)
      .style("color", myChart?.props?.xAxisColor || "#8A98AB")
      .style("cursor", selectXaxis ? "pointer" : "default")
      // .attr("transform", "translate(0," + (height) + ")")
      .attr(
        "transform",
        "translate(" +
          (axisTop
            ? myChart.scatter
              ? 20
              : -5
            : myChart.scatter
            ? -myChart.props?.xAxisFontSize * 2
            : -21) +
          "," +
          (axisTop
            ? cellwidth >= 62
              ? -25
              : myChart.scatter
              ? -myChart.props?.xAxisFontSize * 3
              : -35
            : height +
              (myChart.scatter ? myChart.props?.xAxisFontSize - 10 + 17 : 25)) +
          ")"
      )
      .call(d3.axisBottom(x).tickSize(0))
      .select(".domain")
      .remove();
    // Select ticks
    const Xticks = svg.selectAll(".x-axis .tick");

    // Format text labels
    Xticks.select("text")
      .style("cursor", (d: any) =>
        d == pseudoDate || selectXaxis ? "pointer" : "default"
      )
      .attr(
        "transform",
        myChart.scatter
          ? "translate(0,0) rotate(-45)"
          : "rotate(" +
              (cellwidth >= 62 ? 0 : -45) +
              ")translate(" +
              (cellwidth >= 62 ? (axisTop ? 0 : 20) : axisTop ? 20 : 0) +
              "," +
              (cellwidth >= 62 ? (axisTop ? 0 : -15) : axisTop ? 10 : 0) +
              ")"
      )
      .text((d: any) => (d == pseudoDate ? "Total" : xTickFormat(new Date(d))));

    if (isNav) {
      // Append arrow icon (SVG path) next to each tick
      Xticks.filter((d: any) => d != pseudoDate)
        .append("path")
        .attr(
          "d",
          "M0.0132942 0.107478C-0.0138363 0.172516 0.00147353 0.247304 0.0508594 0.297049L3.75416 4.00001L0.0512184 7.70295C0.00147385 7.7527 -0.0134772 7.82817 0.0133108 7.89252C0.0400825 7.95756 0.103735 8 0.17399 8L3.30442 8C3.35068 8 3.39486 7.98156 3.42755 7.94921L7.25364 4.12312C7.28738 4.08903 7.30443 4.04452 7.30443 3.99999C7.30443 3.95546 7.28739 3.91095 7.25364 3.87686L3.42755 0.0507716C3.39486 0.0184239 3.35068 -1.63589e-05 3.30442 -1.63569e-05L0.17399 -1.62201e-05C0.103734 -4.53439e-09 0.0400822 0.0424399 0.0132942 0.107478Z"
        )
        .attr("fill", "#1363DF")
        .attr("transform", "translate(26,2.5) scale(0.9)") // position & scale arrow
        .style("cursor", "pointer")
        .on("click", (event, d: any) => {
          // console.log("Clicked arrow for tick:", d);
          // 👉 custom click logic here
        });
    }
    // .call(wrap, 40)
    if (selectXaxis) {
      Xticks.on("mouseover", function (event: any, d: any) {
        // Increase font size on mouseover
        d3.select(this)
          .select("text")
          .style("color", d == pseudoDate ? "#8A98AB" : "#1363DF")
          .style("font-weight", 600); // Adjust the font size as needed
      })
        .on("mouseout", function (event: any, d: any) {
          // Reset font size on mouseout
          d3.select(this)
            .select("text")
            .style("color", "#8A98AB")
            .style("font-weight", 500); // Reset to the original font size
        })
        .on("click", function (event: any, d: any) {
          if (isNav && d != pseudoDate) {
            const period: any = new Date(d);
            let controlChartData: any = {
              buffer_days: myChart.filterService?.buffer_days || 0,
              from_date: moment(period).startOf("month").format("YYYY-MM-DD"),
              to_date: moment(period).endOf("month").format("YYYY-MM-DD"),
              // patient_type_name:'unlinked'
            };

            myChart.notCompareClick(controlChartData);
          }
          axisRoot()
            .selectAll(".x-axis .tick text")
            .style("font-size", "10px")
            .style("color", "#8A98AB");
          // Drop every outline first: column outlines sit in the X-axis tick groups, the
          // row outline in the Y-axis tick group plus the scrolling chart SVG.
          axisRoot().selectAll(".x-axis .tick  rect:not(.rowButton)").remove();
          axisRoot().selectAll(".y-axis .tick  rect:not(.rowButton)").remove();
          svg.selectAll(".rowOutline").remove();
          // handleCellClick toggles, so clicking the selected column clears it and the
          // outline stays off.
          if (!myChart.selectedRows.has(d)) {
            drawColumnOutline(d, 2.5);
          }
          handleCellClick(XaxisVar, d, false);
        });
    }

    // Build Y scales and axis:
    var y: any = d3
      .scaleBand()
      .range([height, 0])
      .domain(myVars)
      .padding(cellGap);
    svg
      .append("g")
      .classed("y-axis", true)
      .attr("visibility", !myChart?.props?.yAxisShow ? "hidden" : "visible")
      .style("font-size", myChart?.props?.yAxisFontSize || 12)
      .style("font-family", "Poppins")
      .style("font-weight", myChart?.props?.yAxisBold ? "bold" : 500)
      .style("color", myChart?.props?.yAxisColor || "#101D42")
      .style("cursor", selectYaxis ? "pointer" : "default")
      .attr(
        "transform",
        `translate(${
          !isYAxisResizable && !myChart.scatter
            ? -(this.currentYAxisWidth + 35)
            : 0
        }, 0)`
      )
      .call(d3.axisLeft(y).tickSize(0))
      .select(".domain")
      .remove();

    svg.selectAll(".y-axis .tick line").attr("stroke", "none");

    let maxTextHeight: any = 0;
    const textHeights: any = [];
    let wordSplitLength = Math.floor(this.currentYAxisWidth / 6);
    if (myChart.scatter) {
      svg.selectAll(".y-axis .tick text").each(function (d: any) {
        const text = d3.select(this);
        const words = d.split(" / "); // Splitting by " / " for multi-line effect
        text.text(null); // Clear existing text
        text
          .style("text-anchor", "start")
          .attr("transform", `translate(${-myChart.currentYAxisWidth}, 0)`);

        let temp = words[0];
        words[0] = words[1];
        words[1] = temp;
        words.forEach((word: any, i: any) => {
          if (i > 1) return; // limit to 2 lines only
          let displayWord = word;
          let truncated = false;

          if (word.length > wordSplitLength) {
            displayWord = word.substring(0, wordSplitLength) + "...";
            truncated = true;
          }

          const tspan = text
            .append("tspan")
            .attr("x", -20) // Adjust X position
            .attr("dy", i === 0 ? "0em" : "1.1em") // Stagger lines downward
            // ,attr("margin" )
            .text(displayWord);

          if (truncated) {
            tspan
              .style("cursor", selectYaxis ? "pointer" : "default")
              .on("mouseover", (event: any) =>
                myChart.showSimpleTooltip(event, word, margin.top)
              )
              .on("mouseout", () => myChart.hideSimpleTooltip());
          }

          // text below the source should be gray and smaller
          if (i > 0) {
            tspan
              .attr("font-size", myChart?.props?.yAxisFontSize - 2 || 10)
              .attr("fill", "gray");
          }
        });
      });
      svg.selectAll(".y-axis .tick text").each(function (d) {
        if (this) {
          const textElement = this as SVGTextElement; // typecast `this` to `SVGTextElement`
          const bbox = textElement.getBBox(); // now TypeScript knows `getBBox` exists
          textHeights.push(bbox.height); // store the height of each text element
        }
      });
      // Make sure height is considering the size of our textboxes
      const yAxis = svg.select(".y-axis").node() as SVGGraphicsElement;
      const bbox = yAxis.getBBox();
      y.range([0, bbox.height]);
      maxTextHeight = d3.max(textHeights);
      // below line ensures that the y axis fits below the chart and is not cut off by the card
      svgcontainer.attr(
        "height",
        bbox.height + margin.bottom + margin.top + 12
      );
      // Need to redraw the yaxis
      svg
        .select(".y-axis")
        .call(d3.axisLeft(y).tickSizeOuter(0) as any)
        .selectAll(".tick text")
        .each(function (d: any) {
          const text = d3.select(this);
          const words = d.split(" / "); // Splitting by " / " for multi-line effect
          text.text(null); // Clear existing text
          text
            .style("text-anchor", "start")
            .attr(
              "transform",
              `translate(${
                -myChart.currentYAxisWidth -
                8 -
                myChart.props?.yAxisFontSize * 2 +
                25
              }, -2.25)`
            );

          let temp = words[0];
          words[0] = words[1];
          words[1] = temp;
          words.forEach((word: any, i: any) => {
            if (i > 1) return; // limit to 2 lines only
            let displayWord = word;
            let truncated = false;
            if (word.length > wordSplitLength) {
              displayWord = word.substring(0, wordSplitLength) + "...";
              truncated = true;
            }

            const tspan = text
              .append("tspan")
              .attr("x", -20) // Adjust X position
              .attr("dy", i === 0 ? "0em" : "1.1em") // Stagger lines downward
              .text(displayWord);

            if (truncated) {
              tspan
                .style("cursor", selectYaxis ? "pointer" : "default")
                .on("mouseover", (event: any) =>
                  myChart.showSimpleTooltip(event, word, margin.top)
                )
                .on("mousemove", (event: any) =>
                  myChart.showSimpleTooltip(event, word, margin.top)
                )
                .on("mouseout", () => myChart.hideSimpleTooltip());
            }

            // text below the source should be gray and smaller
            if (i > 0) {
              tspan
                .attr("font-size", myChart?.props?.yAxisFontSize - 2 || 10)
                .attr("fill", "gray");
            }
          });
        });
      svg
        .select(".y-axis")
        .select(".domain") // selects the domain path
        .remove();

      svg.selectAll(".y-axis .tick").each(function (d: any) {
        const tick = d3.select(this);
        // Coordinates for placing the box
        const yPosition = 0;
        const xPosition = -(
          myChart.currentYAxisWidth +
          myChart.props?.yAxisFontSize * 2 +
          30
        ); // further left than text

        // Change the tick line color
        tick.select("line").attr("stroke", "none"); // Hide the tick line

        const button: any = tick
          .append<SVGGElement>("g")
          .classed("control-chart-button", true);

        // Append a transparent rect for better clickability
        button
          .append("rect")
          .attr("x", xPosition + 5)
          .attr("y", yPosition - 10)
          .attr("width", 18)
          .attr("height", 18)
          .attr("fill", "transparent")
          .style("cursor", "pointer");

        // Append the SVG icon using <use>
        button
          .append("use")
          .attr("href", "#arrow-icon-symbol")
          .attr("x", xPosition + 5)
          .attr("y", yPosition - 10)
          .attr("width", 18) // Adjust width as needed
          .attr("height", 18) // Adjust height as needed
          .style("pointer-events", "none"); // Let clicks pass through to the group/rect

        button.style("cursor", "pointer").on("click", () => {
          // Put your click action here
          // console.log("Clicked box for", d);
          let match = data.find((obj: any) => obj.distinct_name == d);
          let controlChartData: any = {
            source_nm: match.source_name,
            kpi_key: match.kpi_key,
            sp_location_key: null,
            sp_location_name: match.sp_location_name,
            x_axis_key: match.x_axis_key,
            y_axis_key: match.y_axis_key,
          };
          if (match.sp_location_key) {
            controlChartData.sp_location_key = match.sp_location_key;
          }
          myChart.notCompareClick(controlChartData);
        });

        const bbox = button.node().getBBox();
        const cx = bbox.x + bbox.width / 2;
        const cy = bbox.y + bbox.height / 2;

        button
          .on("mouseover", function (this: SVGGElement) {
            d3.select(this)
              .transition()
              .duration(200)
              .attr(
                "transform",
                `translate(${cx}, ${cy}) scale(1.2) translate(${-cx}, ${-cy})`
              );
          })
          .on("mouseout", function (this: SVGGElement) {
            d3.select(this)
              .transition()
              .duration(500)
              .attr(
                "transform",
                `translate(${cx}, ${cy}) scale(1) translate(${-cx}, ${-cy})`
              ); // reset transform
          });
      });
    } else if (isYAxisResizable) {
      svg.selectAll(".y-axis .tick text").each(function (d: any) {
        const text = d3.select(this);
        const word = d; // No splitting needed
        text.text(null); // Clear existing text
        text
          .style("text-anchor", "start")
          .attr("transform", `translate(${-myChart.currentYAxisWidth}, 0)`); // Use 0 to align with tick

        let displayWord = word;
        let truncated = false;

        // Use wordSplitLength calculated earlier
        if (word.length > wordSplitLength) {
          displayWord = word.substring(0, wordSplitLength) + "...";
          truncated = true;
        }

        const tspan = text
          .append("tspan")
          .attr("x", -20) // Adjust X position
          .attr("dy", "0.32em") // Center vertically
          .text(displayWord);

        if (truncated) {
          tspan
            .style("cursor", selectYaxis ? "pointer" : "default")
            .on("mouseover", (event: any) =>
              myChart.showSimpleTooltip(event, word, margin.top)
            )
            .on("mousemove", (event: any) =>
              myChart.showSimpleTooltip(event, word, margin.top)
            )
            .on("mouseout", () => myChart.hideSimpleTooltip());
        }
      });
    }

    let scatter = myChart.scatter;

    const Yticks = svg.selectAll(".y-axis .tick");
    if (isNav) {
      // Append arrow icon (as sibling inside tick <g>)
      Yticks.each(function (d: any) {
        const textEl = d3.select(this).select("text").node() as SVGTextElement;

        if (textEl) {
          // Measure the actual text length in pixels
          const textLength = textEl.getComputedTextLength();

          // Append arrow right after the text
          d3.select(this)
            .append("path")
            .attr(
              "d",
              "M0.0132942 0.107478C-0.0138363 0.172516 0.00147353 0.247304 0.0508594 0.297049L3.75416 4.00001L0.0512184 7.70295C0.00147385 7.7527 -0.0134772 7.82817 0.0133108 7.89252C0.0400825 7.95756 0.103735 8 0.17399 8L3.30442 8C3.35068 8 3.39486 7.98156 3.42755 7.94921L7.25364 4.12312C7.28738 4.08903 7.30443 4.04452 7.30443 3.99999C7.30443 3.95546 7.28739 3.91095 7.25364 3.87686L3.42755 0.0507716C3.39486 0.0184239 3.35068 -1.63589e-05 3.30442 -1.63569e-05L0.17399 -1.62201e-05C0.103734 -4.53439e-09 0.0400822 0.0424399 0.0132942 0.107478Z"
            )
            .attr("fill", "#1363DF")
            .attr(
              "transform",
              `translate(${
                textLength +
                (myChart.scatter || isYAxisResizable
                  ? -myChart.currentYAxisWidth
                  : 0)
              }, -3) scale(0.9)`
            )
            // 6px padding after text
            .style("cursor", "pointer")
            .on("click", () => {
              // console.log("Clicked arrow for tick:", d);
              // 👉 custom click logic here
            });
        }
      });
    }
    // Dashed outline for a selected row, drawn in two halves. The label half lives in the
    // Y-axis tick group, which buildFrozenPane moves into the frozen overlay SVG where it
    // is clipped at the frozen width; the cell half lives in the scrolling chart SVG so it
    // spans and scrolls with the month columns. Both use the same geometry and the cell
    // half's left edge is hidden behind the opaque frozen pane, so together they read as a
    // single dashed rectangle.
    const drawRowOutline = (yValue: any) => {
      svg
        .append("rect")
        .datum(yValue)
        .attr("class", "rowOutline")
        .attr("x", -margin.left)
        .attr("y", y(yValue) - 1)
        .attr("width", widths + margin.left)
        .attr("height", y.bandwidth() + 2)
        .attr("rx", 2.5)
        .attr("ry", 2.5)
        .style("fill", "none")
        .style("stroke", "#1363DF")
        .style("stroke-width", 2)
        .style("stroke-dasharray", 4)
        // Must not swallow clicks on the cells it outlines.
        .style("pointer-events", "none");

      axisRoot()
        .selectAll(".y-axis .tick ")
        .filter((d1: any) => d1 == yValue)
        .append("rect")
        .attr("class", "xAxisSelectedTick")
        .attr("x", isYAxisResizable ? 0 : -5)
        .attr("y", -(y.bandwidth() + 2) / 2)
        .attr("width", isYAxisResizable ? widths : widths + margin.left)
        .attr("height", y.bandwidth() + 2)
        .attr("rx", 2.5)
        .attr("ry", 2.5)
        .style("fill", "none")
        .style("stroke", "#1363DF")
        .style("stroke-width", 2)
        .style("stroke-dasharray", 4)
        // The frozen pane sets pointer-events:all on its content, which would make this
        // transparent rect swallow clicks on the row underneath.
        .style("pointer-events", "none");
    };

    // Dashed outline for a selected column. Lives in the X-axis tick group so it travels
    // into the frozen pane along with the Total column's tick when that column is frozen.
    // The Total column is never outlined: it is the default selection, so the box would be
    // on screen permanently. It still selects and still feeds the grid.
    const drawColumnOutline = (xValue: any, cornerRadius: number) => {
      if (xValue == pseudoDate) return;
      const tickGroup = axisRoot()
        .selectAll(".x-axis .tick ")
        .filter((d1: any) => d1 == xValue);
      tickGroup
        .append("rect")
        .raise()
        .raise()
        .attr("class", "yAxisSelectedTick")
        .attr(
          "x",
          scatter
            ? (x.bandwidth() - 18) / 2 - 2
            : -x.bandwidth() / 2 + (axisTop ? 3 : 19)
        )
        .attr("y", axisTop ? 25 : -height - 25)
        .attr("width", x.bandwidth() + 4)
        .attr("height", height + 2)
        .attr("rx", cornerRadius)
        .attr("ry", 2.5)
        .style("fill", "none")
        .style("stroke", "#1363DF")
        .style("stroke-width", 2)
        .style("stroke-dasharray", 4)
        // The Total column's tick is moved into the frozen pane, whose content has
        // pointer-events:all — without this the outline swallows cell clicks.
        .style("pointer-events", "none");
      tickGroup.style("font-size", "11px").style("color", "#1363DF");
    };

    if (selectYaxis) {
      Yticks.style("text-anchor", "start")
        .on("mouseover", function (event: any, d: any) {
          // Increase font size on mouseover
          d3.select(this)
            .style("color", "#1363DF")
            .style("font-size", myChart.scatter ? "12px" : "12px")
            .style("font-weight", 600); // Adjust the font size as needed
        })
        .on("mouseout", function (event: any, d: any) {
          // Reset font size on mouseout
          d3.select(this)
            .style("color", "#101D42")
            .style("font-size", "12px")
            .style("font-weight", 500); // Reset to the original font size
        })
        .on("click", function (event: any, d: any) {
          // Select all tick elements and append text and a rectangle to each one
          if (isNav) {
            let controlChartData: any = {
              buffer_days: myChart.filterService?.buffer_days || 0,
              source_nm: d,
              //  patient_type_name:'unlinked'
            };

            myChart.notCompareClick(controlChartData);
          }
          axisRoot()
            .selectAll(".x-axis .tick text")
            .style("font-size", "10px")
            .style("color", "#8A98AB");
          // Drop every outline first: column outlines sit in the X-axis tick groups, the
          // row outline in the Y-axis tick group plus the scrolling chart SVG.
          axisRoot().selectAll(".x-axis .tick  rect:not(.rowButton)").remove();
          axisRoot().selectAll(".y-axis .tick  rect:not(.rowButton)").remove();
          svg.selectAll(".rowOutline").remove();
          // handleCellClick toggles, so clicking the selected row clears it and the
          // outline stays off.
          if (!myChart.selectedRows.has(d)) {
            drawRowOutline(d);
          }
          handleCellClick(YaxisVar, d, true);
        });
    }

    // Method to determine the color based on value
    function getColor(value: number): string {
      let colorRange: any = [];
      if (scatter) {
        colorRange = [
          "#D01345",
          "#d47993",
          "#8fddb2",
          "#3bc77d",
          "#8fddb2",
          "#d47993",
          "#D01345",
        ];
      } else {
        colorRange = [
          "#1F10D1B2",
          "#1F10D180",
          "#1F10D14D",
          "#3DC77B",
          "#F1B7C7",
          "#ECA1B5",
          "#D01345",
        ];
      }
      // Loop through the intervals to determine which range the value falls into
      for (let i = 0; i < intervals.length; i++) {
        if (value >= intervals[i][0] && value <= intervals[i][1]) {
          // For the zero case, return the corresponding color
          if (value === 0) {
            return colorRange[3]; // Return the color for 0
          }
          return colorRange[i];
        }
      }

      // Default color if value doesn't match any range (optional)
      return "#000000"; // black or any default color you prefer
    }

    // Fades for our green, red, and blue colors in the heatmap
    let greenFade = d3
      .scaleLinear()
      .domain([0, 2]) // Closer to 0 = stronger green
      .range([1, 0.2])
      .clamp(true);

    let redFade = d3
      .scaleLinear()
      .domain([2, MaxValue]) // Further from +2 = stronger red
      .range([0.2, 1])
      .clamp(true);
    let blueFade = d3
      .scaleLinear()
      .domain([min, this.lowerBound]) // Further from -2 = stronger red
      .range([0.2, 1])
      .clamp(true);
    // add the squares
    svg
      .append("g")
      .classed("heatmap-group", true)
      .selectAll()
      .data(data, function (d: any) {
        return d[XaxisVar] + ":" + d[YaxisVar];
      })
      .enter()
      .append("rect")
      .attr("class", "heatma-cell")
      .attr("x", function (d: any) {
        return x(d[XaxisVar]);
      })
      .attr("y", function (d: any) {
        return y(d[YaxisVar]);
      })
      .attr("rx", cellRadius ? 2.5 : 0)
      .attr("ry", cellRadius ? 2.5 : 0)
      .attr("width", 0) //x.bandwidth() )
      .attr("height", 0) //y.bandwidth() )
      .attr(
        "transform",
        myChart.scatter
          ? `translate(0, 0)`
          : `translate(${x.bandwidth() / 2}, ${y.bandwidth() / 2})`
      )
      .style("fill", function (d: any) {
        if (myChart.scatter) {
          if (d[valueVar] > 2) {
            return myChart.red;
          } else if (d[valueVar] < -2) {
            return myChart.blue;
          } else {
            // between lower and upperbound
            return myChart.green;
          }
        } else {
          return d[XaxisVar] == pseudoDate
            ? "#1F10D180"
            : colorGradient
            ? d[valueVar] == "N/A"
              ? "#a5aebbe8"
              : colorScale(d[valueVar])
            : myChart.selectedValue == "percent"
            ? getColor(d[valueVar])
            : myChart.valueColourRange(myChart.numberRange, d[valueVar]);
        }
      })
      .style("cursor", (d: any) =>
        d[valueVar] == "N/A" ? "default" : "pointer"
      )
      // .style("stroke-width", 4)
      // .style("stroke", "none")
      .on("click", function (event: any, d: any) {
        event.stopPropagation();
        let commentPopup = myChart.item?.['config']?.commentPopup || false;
        if(commentPopup) {
          if (d[valueVar] == "N/A") return;
          if (myChart._clickTimer) {
            clearTimeout(myChart._clickTimer);
            myChart._clickTimer = null;
          }
          myChart._clickTimer = setTimeout(() => {
            myChart.openCommentPopup(d, XaxisVar, YaxisVar);
            myChart._clickTimer = null;
          }, 250);
        } else {
          if (d[valueVar] == "N/A") return;
          if (myChart._clickTimer) {
            clearTimeout(myChart._clickTimer);
            myChart._clickTimer = null;
          }
          if (isNav) {
            const period: any = new Date(d[XaxisVar]);
            let controlChartData: any = {
              buffer_days: myChart.filterService?.buffer_days || 0,
              source_nm: d[YaxisVar],
              from_date: moment(period).startOf("month").format("YYYY-MM-DD"),
              to_date: moment(period).endOf("month").format("YYYY-MM-DD"),
            };
            if (d[XaxisVar] === pseudoDate) {
              delete controlChartData.from_date;
              delete controlChartData.to_date;
            }
            myChart.notCompareClick(controlChartData);
          }
        }
      })
      .on("dblclick", function (event: any, d: any) {
        event.stopPropagation();
        let commentPopup = myChart.item?.['config']?.commentPopup || false;
        if(!commentPopup) return;
        if (d[valueVar] == "N/A") return;
        if (myChart._clickTimer) {
          clearTimeout(myChart._clickTimer);
          myChart._clickTimer = null;
        }
        if (isNav) {
          const period: any = new Date(d[XaxisVar]);
          let controlChartData: any = {
            buffer_days: myChart.filterService?.buffer_days || 0,
            source_nm: d[YaxisVar],
            from_date: moment(period).startOf("month").format("YYYY-MM-DD"),
            to_date: moment(period).endOf("month").format("YYYY-MM-DD"),
          };
          if (d[XaxisVar] === pseudoDate) {
            delete controlChartData.from_date;
            delete controlChartData.to_date;
          }
          myChart.notCompareClick(controlChartData);
        }
      })
      .on("mouseover", function (event, d) {
        d3.select(this)
          .style("stroke", "#1363DF") // Set the border color
          .style("stroke-width", 2) // Set the border width
          .style("stroke-dasharray", 4);
      })
      .on("mousemove", function (event, d) {
        if (isTooltipShow) {
          const color = d3.select(this).style("fill");
          const [x, y] = d3.pointer(event, myChart.elementRef.nativeElement);
          myChart.showTooltip(
            "myType",
            d,
            event.offsetX,
            event.offsetY,
            width,
            color
          );
        }
      })
      .on("mouseleave", function (event, d) {
        d3
          .select(this)
          .style("stroke", "none") // Remove the border on mouseleave
          .style("stroke-width", 0),
          myChart.hideTooltip(false);
      })
      .style("opacity", 0.2)
      .transition()
      .duration(animate ? 1200 : 0)
      .attr("width", x.bandwidth())
      .attr("height", y.bandwidth())
      .style("opacity", function (d: any) {
        if (myChart.scatter) {
          if (d[valueVar] > 2) {
            return redFade(d[valueVar]);
          } else if (d[valueVar] < -2) {
            return blueFade(d[valueVar]);
          } else {
            // between lower and upperbound
            return greenFade(Math.abs(d[valueVar]));
          }
        } else {
          return 1;
        }
      })
      .attr("transform", "translate(0, 0)");

    // Add comment count badge on cells that have comments (like bar chart orange badge)
    const commentIconSize = 12;
    svg
      .select(".heatmap-group")
      .selectAll(".comment-indicator")
      .data(
        data.filter((d: any) => {
          return d.comment_count > 0;
        }),
        function (d: any) {
          return d.comment_count;
        }
      )
      .enter()
      .append("g")
      .attr("class", "comment-indicator")
      .attr("transform", function (d: any) {
        const cx = x(d[XaxisVar])! + x.bandwidth() - commentIconSize - 2;
        const cy = y(d[YaxisVar])! + 2;
        return `translate(${cx}, ${cy})`;
      })
      .style("cursor", "pointer")
      .style("pointer-events", "all")
      .on("click", function (event: any, d: any) {
        event.stopPropagation();
        myChart.openCommentPopup(d, XaxisVar, YaxisVar);
      })
      .each(function () {
        const g = d3.select(this);
        g.append("circle")
          .attr("cx", commentIconSize / 2)
          .attr("cy", commentIconSize / 2)
          .attr("r", commentIconSize / 2)
          .attr("fill", "#FF6636")
          .attr("stroke", "white")
          .attr("stroke-width", 1);
        g.append("text")
          .attr("x", commentIconSize / 2)
          .attr("y", commentIconSize / 2 + 1)
          .attr("text-anchor", "middle")
          .attr("dominant-baseline", "middle")
          .attr("fill", "white")
          .attr("font-size", "8px")
          .attr("font-weight", "bold")
          .attr("font-family", "Poppins")
          .text(function (d: any) {
            // const count = myChart.getCommentCountForCell(d, XaxisVar, YaxisVar);
            return d.comment_count || 0
          });
      });

    // append text centered inside rect
    if (showCellValue) {
      svg
        .selectAll("text.value")
        .data(data, function (d: any) {
          return d[XaxisVar] + ":" + d[YaxisVar];
        })
        .enter()
        .append("text")
        .attr("class", "cellValue")
        .attr("x", function (d: any) {
          return x(d[XaxisVar]) + x.bandwidth() / 2;
        })
        .attr("y", function (d: any) {
          return y(d[YaxisVar]) + y.bandwidth() / 2;
        })
        .attr("dy", ".35em")
        .attr("text-anchor", "middle")
        .style("fill", "black")
        .style("font-size", x.bandwidth() / 4 > 14 ? 14 : x.bandwidth() / 4) // Adjust font size based on cell width
        .style("font-family", "Poppins")
        .style("font-weight", 600)
        .text(function (d: any) {
          return (
            (myChart.selectedValue == "percent"
              ? d[valueVar]
              : myChart.numbedPipe(d[valueVar])) +
            (myChart.selectedValue == "percent" && d[valueVar] != "N/A"
              ? "%"
              : "")
          );
        })
        .style("cursor", (d: any) =>
          d[valueVar] == "N/A" ? "default" : "pointer"
        )
        // .style("stroke-width", 4)
        // .style("stroke", "none")
        .on("click", function (event, d: any) {
          event.stopPropagation();
          let commentPopup = myChart.item?.['config']?.commentPopup || false;
          if(commentPopup) {
            if (d[valueVar] == "N/A") return;
            if (myChart._clickTimer) {
              clearTimeout(myChart._clickTimer);
              myChart._clickTimer = null;
            }
            myChart._clickTimer = setTimeout(() => {
              myChart.openCommentPopup(d, XaxisVar, YaxisVar);
              myChart._clickTimer = null;
            }, 250);
          } else {
            if (d[valueVar] == "N/A") return;
            if (myChart._clickTimer) {
              clearTimeout(myChart._clickTimer);
              myChart._clickTimer = null;
            }
            if (isNav) {
              const period: any = new Date(d[XaxisVar]);
              let controlChartData: any = {
                buffer_days: myChart.filterService?.buffer_days || 0,
                source_nm: d[YaxisVar],
                from_date: moment(period).startOf("month").format("YYYY-MM-DD"),
                to_date: moment(period).endOf("month").format("YYYY-MM-DD"),
              };
              if (d[XaxisVar] === pseudoDate) {
                delete controlChartData.from_date;
                delete controlChartData.to_date;
              }
              myChart.notCompareClick(controlChartData);
            }
          }
        })
        .on("dblclick", function (event, d: any) {
          event.stopPropagation();
          let commentPopup = myChart.item?.['config']?.commentPopup || false;
          if(!commentPopup) return;
          if (d[valueVar] == "N/A") return;
          if (myChart._clickTimer) {
            clearTimeout(myChart._clickTimer);
            myChart._clickTimer = null;
          }
          if (isNav) {
            const period: any = new Date(d[XaxisVar]);
            let controlChartData: any = {
              buffer_days: myChart.filterService?.buffer_days || 0,
              source_nm: d[YaxisVar],
              from_date: moment(period).startOf("month").format("YYYY-MM-DD"),
              to_date: moment(period).endOf("month").format("YYYY-MM-DD"),
            };
            if (d[XaxisVar] === pseudoDate) {
              delete controlChartData.from_date;
              delete controlChartData.to_date;
            }
            myChart.notCompareClick(controlChartData);
          }
        });
    }

    // Function to handle cell click
    const handleCellClick = (
      axisVar: any,
      selectedRowData: any,
      pivot: boolean
    ) => {
      const selectedRowIndex = selectedRowData;

      // Toggle selection of the row
      if (this.selectedRows.has(selectedRowIndex)) {
        this.selectedRows.delete(selectedRowIndex);
      } else {
        this.selectedRows.clear();
        this.selectedRows.add(selectedRowIndex);
      }

      // Update the styling based on selected rows
      updateRowSelection(axisVar);

      // Display the selected row data
      displaySelectedRowData(axisVar, pivot, selectedRowData);
    };

    // Function to update row selection styling
    const updateRowSelection = (axisVar: any) => {
      svg
        .selectAll("rect") //.attr("width", (d: any) => this.selectedRows.has(d[axisVar]) ?42: x.bandwidth()  )
        .classed("selected-row", (d: any) => this.selectedRows.has(d[axisVar]));
    };

    // Function to display selected row data
    const displaySelectedRowData = (
      axisVar: any,
      pivot: boolean,
      selectedValue: any
    ) => {
      const selectedRowData = data.filter((d: any) =>
        this.selectedRows.has(d[axisVar])
      );
      // console.log('Selected Row Data:', selectedRowData);
      // debugger
      let value = {
        selectedValue: selectedValue,
        data: selectedRowData,
        pivot: pivot,
      };
      setTimeout(() => {
        if (!myChart.scatter) this.gridData.emit(value);
      }, 100);
    };

    // // Add title to graph
    // svg.append("text")
    //       .attr("x", 0)
    //       .attr("y", -50)
    //       .attr("text-anchor", "left")
    //       .style("font-size", "22px")
    //       .text("A d3.js heatmap");

    // // Add subtitle to graph
    // svg.append("text")
    //       .attr("x", 0)
    //       .attr("y", -20)
    //       .attr("text-anchor", "left")
    //       .style("font-size", "14px")
    //       .style("fill", "grey")
    //       .style("max-width", 400)
    //       .text("A short description of the take-away message of this chart.");

    function wrap(text: any, width: any): void {
      text.selectAll("tspan").remove();

      text.each(function (): any {
        let lineNumber = 0;
        //@ts-ignore
        const text = d3.select(this);
        const words = text.text().split(/\s+/).reverse();
        let word = null;
        let line: any = [];
        const lineHeight = 10;
        const dy = 22;
        let tspan: any = text
          .text(null)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 0)
          .attr("dy", dy + "px");
        while ((word = words.pop())) {
          line.push(word);
          tspan.text(line.join(" "));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            if (line.length > 0) {
              tspan.text(line.join(" "));
              line = [word];
              if (word.trim().length > 0) {
                lineNumber += 1;
                tspan = text
                  .append("tspan")
                  .attr("x", 0)
                  .attr("y", 0)
                  .attr("dy", lineNumber * lineHeight + dy + "px")
                  .text(word);
              }
            } else {
              line = [word];
            }
          }
        }
      });
    }

    function splitNumberIntoRanges(number: any, numberOfRanges: any) {
      let ranges = [];
      const Negranges = [];
      let rangesnumb = [];
      const negrangesnumb = [];
      const rangeSize = Math.ceil(number / numberOfRanges);

      for (let i = 0; i < numberOfRanges; i++) {
        const start = i * rangeSize + 1;
        const end = (i + 1) * rangeSize;
        if (i == 0) {
          negrangesnumb.push("-" + end + " /" + " -" + 0.1);
          rangesnumb.push(0.1 + " / " + end);
          ranges.push(0.1 + " to " + numberFormating(end));
          Negranges.push(
            "(-" + numberFormating(end) + ") to (" + "-" + 0.1 + ")"
          );
        } else {
          negrangesnumb.push("-" + end + " /" + " -" + start);
          rangesnumb.push(start + " / " + end);
          ranges.push(numberFormating(start) + " to " + numberFormating(end));
          Negranges.push(
            "(-" +
              numberFormating(end) +
              ") to (" +
              "-" +
              numberFormating(start) +
              ")"
          );
        }
      }
      ranges.unshift("0");
      rangesnumb.unshift("0/0");
      ranges = [...Negranges.reverse(), ...ranges];
      myChart.numberRange = [...negrangesnumb.reverse(), ...rangesnumb];
      // ranges.unshift(Negranges.reverse());
      // console.log(myChart.numberRange)
      return ranges;
    }

    function numberFormating(value: any) {
      return d3.format(".3~s")(value);
    }
    // Re-apply whatever is currently selected so a re-render — resize, fullscreen
    // enter/exit, Y-axis resize, preference change — keeps the same row or column
    // selected, redraws its outline and re-emits the same rows to the linked grid.
    // handleCellClick toggles, so it is only used for a fresh selection; falling back to
    // it unconditionally would de-select an already selected column and empty the grid.
    const activeSelection: any[] = [...myChart.selectedRows];
    const selectedRow = activeSelection.find((s: any) => myVars.includes(s));
    const selectedColumn = activeSelection.find((s: any) => myGroups.includes(s));
    if (selectedRow !== undefined) {
      updateRowSelection(YaxisVar);
      displaySelectedRowData(YaxisVar, true, selectedRow);
      if (selectYaxis) drawRowOutline(selectedRow);
    } else {
      const column = selectedColumn !== undefined ? selectedColumn : myGroups[0];
      if (selectedColumn !== undefined) {
        updateRowSelection(XaxisVar);
        displaySelectedRowData(XaxisVar, false, column);
      } else {
        handleCellClick(XaxisVar, column, false);
      }
      if (!myChart.scatter && selectXaxis) drawColumnOutline(column, 200.5);
    }

    // --- Slider Implementation ---
    if (isYAxisResizable) {
      const rectWidth = 2; // Wider for easier grabbing
      const rectHeight = Math.abs(y.range()[0] - y.range()[1]); // Match axis height dynamically
      const startX = margin.left - 5; // Position slightly to the left of the chart area
      const startY = margin.top; // Start at the top of the axis
      const borderRadius = 1;

      // Select or create the group
      let group: any = svgcontainer.select("#resizeGroup" + myClass);
      if (group.empty()) {
        group = svgcontainer.append("g").attr("id", "resizeGroup" + myClass);
      }

      // Update group position (important for re-renders)
      // We don't remove the group, just update its content/position if needed.
      // Actually, we should just update the rect position or the group transform?
      // The group contains the rect. The rect is at 0,0 relative to group.
      // The group is translated by startX.
      // Since startX changes with margin.left, we must update the group's transform.

      // However, if we are dragging, we don't want to snap the slider to the calculated margin.left
      // immediately if it causes a feedback loop?
      // Actually, margin.left IS calculated from currentYAxisWidth.
      // So startX IS correct.

      // Ensure the group is raised to be on top
      group.raise();

      // Remove existing rectangle before adding new ones (to ensure clean state or update props)
      // Or better, select and update.
      let rectGroup = group.select(".resizeRect" + myClass);
      if (rectGroup.empty()) {
        rectGroup = group.append("g").attr("class", "resizeRect" + myClass);

        rectGroup
          .append("rect")
          .attr("x", -rectWidth / 2)
          .attr("width", rectWidth)
          .attr("height", rectHeight)
          .attr("rx", borderRadius)
          .attr("ry", borderRadius)
          .attr("fill", "#d0d0d0") // Visible gray
          .style("cursor", "ew-resize")
          .on("mouseover", function () {
            //@ts-ignore
            d3.select(this).attr("width", 4).attr("fill", "#a8a8a8"); // hover color
          })
          .on("mouseout", function () {
            //@ts-ignore
            d3.select(this).attr("width", rectWidth).attr("fill", "#d0d0d0"); // reset to default
          });
      }

      rectGroup.call(
        (d3.drag() as any).on("drag", function (this: any, event: any) {
          // Use event.dx for relative movement
          const dx = event.dx;

          // Calculate new width
          let newWidth = myChart.currentYAxisWidth + dx;

          // Clamp
          const minWidth = minLabelWidthPx;
          const maxWidth = maxLabelWidthPx;

          if (newWidth < minWidth) newWidth = minWidth;
          if (newWidth > maxWidth) newWidth = maxWidth;

          if (newWidth !== myChart.currentYAxisWidth) {
            myChart.currentYAxisWidth = newWidth;
            myChart.plotChart(false);
          }
        })
      );

      // Update position of the slider group to match the new margin
      // We update the group transform, NOT the rectGroup transform (which is inside).
      // Wait, previous code translated rectGroup. Let's translate the main group or rectGroup?
      // Previous: group appended rectGroup translated by startX.
      // Let's translate rectGroup.
      rectGroup.attr("transform", `translate(${startX}, ${startY})`);

      // Update rect dimensions if height changed
      rectGroup.select("rect").attr("height", rectHeight);

      /*
      if (xPosition >= minX && xPosition <= maxX) {
        d3.select(this).attr("transform", `translate(${xPosition}, 0)`);
        myChart.currentYAxisWidth = xPosition - 40 + 10; // Adjust back to width
        // console.log("New Width:", myChart.currentYAxisWidth);
        myChart.plotChart();
      }
      */
    } else {
      // If not resizable, remove the group if it exists
      svgcontainer.select("#resizeGroup" + myClass).remove();
    }

    // ===== Freeze the Y-axis (row labels) + Total column =====
    // Relocates the already-drawn frozen nodes into a fixed overlay SVG so only the
    // month columns scroll. Done last so every node (cells, badges, values, slider)
    // exists and keeps its D3 event handlers when moved.
    this.buildFrozenPane(
      svg,
      svgcontainer,
      myClass,
      margin,
      x,
      height,
      myGroups,
      XaxisVar,
      pseudoDate
    );
  }

  /**
   * Moves the Y-axis label group and the Total column (cells + value labels +
   * comment badges + header tick) out of the scrolling chart SVG and into the fixed
   * #Yaxis overlay SVG. Nodes are physically re-parented (not cloned), so their D3
   * event handlers, colors, tooltips and transitions are preserved. The overlay mirrors
   * the chart's translate so moved nodes keep their exact on-screen position.
   */
  private buildFrozenPane(
    svg: any,
    svgcontainer: any,
    myClass: string,
    margin: any,
    x: any,
    height: number,
    myGroups: any[],
    XaxisVar: string,
    pseudoDate: any
  ): void {
    const fsvg = d3.select<SVGSVGElement, unknown>("#svg_Yaxis" + myClass);
    if (fsvg.empty() || !fsvg.node()) return;

    const fullHeight =
      +svgcontainer.attr("height") || height + margin.top + margin.bottom;
    // Only freeze the Total column when it is the left-most column (descending order).
    const hasTotal = myGroups[0] === pseudoDate;
    const bw = typeof x.bandwidth === "function" ? x.bandwidth() : 0;
    const frozenWidth = Math.round(margin.left + (hasTotal ? bw : 0));

    // Reset the overlay each render.
    fsvg.selectAll("*").remove();
    fsvg
      .attr("width", frozenWidth)
      .attr("height", fullHeight)
      // Transparent to pointer events by default; only the label/cell content re-enables them.
      .style("pointer-events", "none");

    // Opaque background hides any month cells that scroll underneath the frozen pane.
    fsvg
      .append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", frozenWidth)
      .attr("height", fullHeight)
      .attr("fill", "#ffffff")
      .style("pointer-events", "none");

    // Content group mirrors the chart-content translate so moved children keep position.
    const fContent = fsvg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`)
      .style("pointer-events", "all");
    const fNode = fContent.node() as SVGGElement;

    // Move the Y-axis group (row labels, arrows, control-chart buttons) — keeps handlers.
    const yAxisNode = svg.select(".y-axis").node() as SVGGElement | null;
    if (yAxisNode) fNode.appendChild(yAxisNode);

    if (hasTotal) {
      // Move the "Total" header tick into a group that replicates the x-axis transform/styles.
      const xAxisG = svg.select(".x-axis");
      if (!xAxisG.empty()) {
        const fX = fContent
          .append("g")
          .attr("class", "x-axis")
          .attr("transform", xAxisG.attr("transform"))
          .style("font-size", this.props?.xAxisFontSize || 10)
          .style("font-family", "Poppins")
          .style("font-weight", this.props?.xAxisBold ? "bold" : 500)
          .style("color", this.props?.xAxisColor || "#8A98AB");
        const fxNode = fX.node() as SVGGElement;
        xAxisG
          .selectAll(".tick")
          .filter((d: any) => d === pseudoDate)
          .each(function (this: any) {
            fxNode.appendChild(this);
          });
      }

      // Move the Total-column cells, their comment badges and value labels.
      const hg = svg.select(".heatmap-group");
      if (!hg.empty()) {
        hg.selectAll("rect.heatma-cell")
          .filter((d: any) => d[XaxisVar] === pseudoDate)
          .each(function (this: any) {
            fNode.appendChild(this);
          });
        hg.selectAll(".comment-indicator")
          .filter((d: any) => d[XaxisVar] === pseudoDate)
          .each(function (this: any) {
            fNode.appendChild(this);
          });
      }
      svg
        .selectAll("text.cellValue")
        .filter((d: any) => d[XaxisVar] === pseudoDate)
        .each(function (this: any) {
          fNode.appendChild(this);
        });
    }

    // Keep the Y-axis resize slider usable by moving it into the frozen pane.
    const resizeNode = svgcontainer
      .select("#resizeGroup" + myClass)
      .node() as SVGGElement | null;
    if (resizeNode) {
      (fsvg.node() as SVGSVGElement).appendChild(resizeNode);
      d3.select(resizeNode).style("pointer-events", "all");
    }

    // Rotated x-axis date labels (scatter / narrow cells) of the first scrollable
    // column extend to the left and would slide under the opaque frozen pane.
    // Push the scrollable content right by the measured overlap so they stay visible.
    const scrollEl = this.heatmapContainer?.nativeElement as
      | HTMLElement
      | undefined;
    if (scrollEl) {
      scrollEl.style.paddingLeft = "0px";
      const paneRect = (fsvg.node() as SVGSVGElement).getBoundingClientRect();
      if (this.props?.xAxisShow && paneRect.width > 0) {
        let minLeft = Infinity;
        svg.selectAll(".x-axis .tick text").each(function (this: any) {
          const r = (this as SVGGraphicsElement).getBoundingClientRect();
          if (r.width > 0 && r.left < minLeft) minLeft = r.left;
        });
        const overlap = paneRect.right - minLeft;
        if (isFinite(minLeft) && overlap > 0) {
          scrollEl.style.paddingLeft = Math.ceil(overlap + 6) + "px";
        }
      }
    }
  }

  valueColourRange(ranges: any, value: any) {
    let colorRange: any = [];
    if (this.scatter) {
      colorRange = [
        "#1F10D1B2",
        "#1F10D180",
        "#8fddb2",
        "#3bc77d",
        "#8fddb2",
        "#d47993",
        "#D01345",
      ];
    } else {
      colorRange = [
        "#1F10D1B2",
        "#1F10D180",
        "#1F10D14D",
        "#3DC77B",
        "#F1B7C7",
        "#ECA1B5",
        "#D01345",
      ];
    }
    let colorIndex = 0;
    for (let i = 0; i < ranges.length; i++) {
      const range = ranges[i].split("/");
      const start = parseFloat(range[0]);
      const end = parseFloat(range[1]);

      if (start <= value && value <= end) {
        colorIndex = i;
        break;
      }
    }
    const color = colorRange[colorIndex];
    return color;
  }
  // numberFormat
  numbedPipe(value: any) {
    // If null or undefined, return "--"
    if (value === null || value === undefined) return "--";

    // If string but NOT a valid number → return as it is ("NA", "-", etc.)
    if (typeof value === "string" && isNaN(Number(value))) {
      return value;
    }

    // Convert to number safely
    const num = Number(value);

    // Format using currency pipe (no symbol)
    return this.currency.transform(num, "", "", "1.0-2");
  }

  getTextWidth(
    text: string,
    fontSize: string,
    fontFamily: string = "Inter, sans-serif"
  ): number {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = `${fontSize} ${fontFamily}`;
      return context.measureText(text).width;
    }
    return 0;
  }

  openCommentPopup(d: any, XaxisVar: string, YaxisVar: string): void {
    // Map heatmap data keys to popup-expected keys
    const mappedData = {
      ...d,
      source_key: d.source_key || d.data_source_key,
      dispense_quantity: d.dispense_qty ?? d.dispense_quantity,
      inventory_quantity: d.inventory_qty ?? d.inventory_quantity,
      difference: d.qty_difference ?? d.difference,
      source_name: d.source_name || d[YaxisVar],
      page_nm: 'IR Summary'
    };

    let dateFormat: any = this.filterService.time_cycle;
    // let userState: any = this.userActivityService.getData();
    // let ir_calc_mode = (this.filterService.showByKey == userState['showBy' + this.item.config.showby_name])
    //   ? this.filterService.showByKey
    //   : (userState['showBy' + this.item.config.showby_name] ? userState['showBy' + this.item.config.showby_name] : this.filterService.defaultReport_type);

    const filteredMessages = this.commentsData?.filter((student: any) =>
      student.data_source_key == mappedData.source_key &&
      moment(student.period).format("yyyy-MM-DD") == moment(d[XaxisVar]).format("yyyy-MM-DD") &&
      (dateFormat == student.time_cycle) &&
      student.ir_calc_mode == this.filterService.showByKey
    ) || [];

    const dialogRef = this.dialog.open(IrCommectPopupComponent, {
      height: this.deviceDetectionService.isMobile ? '90%' : 'auto',
      width: this.deviceDetectionService.isMobile ? '90%' : '60%',
      disableClose: true,
      panelClass: ["du-custom-modalbox", "ir-comment-dialog"],
      data: {
        params: {
          params: {
            item: this.item
          },
          value: mappedData,
          data: { ...d, period: d[XaxisVar] },
          colDef: { headerName: d[YaxisVar], field: d[YaxisVar] },
        },
        data: mappedData,
        messages: [...filteredMessages],
        comment_typ: "IRSUM",
      }
    });

    dialogRef.afterClosed().subscribe((value: any) => {
      if (value && Array.isArray(value)) {
        // Remove old comments for this cell from commentsData
        const periodFormatted = moment(d[XaxisVar]).format("yyyy-MM-DD");
        this.commentsData = this.commentsData?.filter((student: any) => !(
          student.data_source_key == mappedData.source_key &&
          moment(student.period).format("yyyy-MM-DD") == periodFormatted &&
          (dateFormat == student.time_cycle) &&
          student.ir_calc_mode == this.filterService.showByKey
        )) || [];

        // Normalize returned comments to ensure filter-matching fields are present
        // (API INSERT response may not include time_cycle/ir_calc_mode/data_source_key)
        const normalizedComments = value.map((comment: any) => ({
          ...comment,
          data_source_key: comment.data_source_key ?? mappedData.source_key,
          period: comment.period ?? d[XaxisVar],
          time_cycle: comment.time_cycle ?? dateFormat,
          ir_calc_mode: comment.ir_calc_mode ?? this.filterService.showByKey,
        }));

        // Add back the updated comments from the popup
        this.commentsData = [...this.commentsData, ...normalizedComments];

        // Update comment_count on the data object so badge reflects the new count
        d.comment_count = value.length;

        // Update badge directly in DOM without re-plotting (preserves selection state)
        const myClass = this.divId;
        const svg = d3.select("#svg_" + myClass);
        const commentIconSize = 12;

        // Remove all existing comment indicators and re-render them
        svg.select(".heatmap-group").selectAll(".comment-indicator").remove();

        const allData = svg.select(".heatmap-group").selectAll("rect").data();
        const commentsDataFiltered = allData.filter((item: any) => item.comment_count > 0);

        // Find existing rects to get positions from them
        const self = this;
        commentsDataFiltered.forEach((cd: any) => {
          const matchingRect = svg.select(".heatmap-group").selectAll("rect")
            .filter((rd: any) => rd[XaxisVar] === cd[XaxisVar] && rd[YaxisVar] === cd[YaxisVar]);

          if (!matchingRect.empty()) {
            const rectX = parseFloat(matchingRect.attr("x"));
            const rectY = parseFloat(matchingRect.attr("y"));
            const rectW = parseFloat(matchingRect.attr("width"));

            const cx = rectX + rectW - commentIconSize - 2;
            const cy = rectY + 2;

            const g = svg.select(".heatmap-group")
              .append("g")
              .attr("class", "comment-indicator")
              .attr("transform", `translate(${cx}, ${cy})`)
              .style("cursor", "pointer")
              .style("pointer-events", "all")
              .on("click", (event: any) => {
                event.stopPropagation();
                self.openCommentPopup(cd, XaxisVar, YaxisVar);
              });

            g.append("circle")
              .attr("cx", commentIconSize / 2)
              .attr("cy", commentIconSize / 2)
              .attr("r", commentIconSize / 2)
              .attr("fill", "#FF6636")
              .attr("stroke", "white")
              .attr("stroke-width", 1);

            g.append("text")
              .attr("x", commentIconSize / 2)
              .attr("y", commentIconSize / 2 + 1)
              .attr("text-anchor", "middle")
              .attr("dominant-baseline", "middle")
              .attr("fill", "white")
              .attr("font-size", "8px")
              .attr("font-weight", "bold")
              .attr("font-family", "Poppins")
              .text(cd.comment_count || 0);
          }
        });
      }
    });
  }
}
